import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
import { checkPrivileges } from "../../Helpers";
import withRoutes from "../../HOC/HocRoutes";
import PoInvoicesDn from "../ProcessInvoices/PoInvoiceDn";
import useDownloadFile from "../../Hooks/useDownloadFile";

const defaultPages = ["account", "device", "group"];

const GarageInvoiceView = (props) => {
  const dispatch = useDispatch();
  const { downloadInvoice } = useDownloadFile(dispatch);
  const logInUser = useSelector((state) => state.logInUsers);
  const themecolors = useSelector((state) => state.themecolors);
  const [sessionCallTrack, setSessionCallTrack] = useState(true);
  const poInvoiceDnsRef = useRef();

  const handleSidebarSearch = ({ to, from, account, vehicle, area }) => {
    if (poInvoiceDnsRef.current) {
      poInvoiceDnsRef.current.getPoInvoicesDns({
        to,
        from,
        account,
        vehicle,
        area,
      });
    }
  };

  const handleDownload = (data, type) => {
    downloadInvoice(
      {
        ...data,
        account: data.contractNumber,
        garageGenerate: true,
      },
      type,
    );
  };

  const controleSession = () => {
    if (localStorage.getItem("userInfo")) {
      fetch("/api/session", { method: "DELETE" })
        .then((res) => res.json())
        .then((response) => {
          if (response.ok) props.navigate("/logout");
          else throw response;
        })
        .catch(() => {});
    }
  };

  useEffect(() => {
    if (!logInUser && sessionCallTrack) {
      setSessionCallTrack(false);
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
          params: { app: "3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05" },
        },
      )
        .then((res) => {
          if (res.ok) {
            res.json().then((res) => {
              if (res.status === "success") {
                const userInfo = res.data;
                props.setActiveLanguage(userInfo?.attributes?.lang || "en");
                dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                const err = res?.message.split(":");
                err[1] = err[1].replace(")", "");
                toast.error(props.translate(err[1]));
                props.navigate("/login");
              }
            });
          } else {
            props.navigate("/login");
            throw res;
          }
        })
        .catch(() => toast.error("somethingWentWrong"));
    }
  }, [logInUser, sessionCallTrack, dispatch, props]);

  if (!logInUser) return null;

  if (checkPrivileges("invoice")) {
    return (
      <Layout
        {...props}
        themecolors={themecolors}
        noSidebar=""
        selecteFilters={handleSidebarSearch}
        currentPath="view"
        downloadInvoices={handleDownload}
      >
        <PoInvoicesDn
          {...props}
          ref={poInvoiceDnsRef}
          backPath="/garage-invoices"
          requiredPrivilege="invoice"
          garageGenerate
        />
      </Layout>
    );
  } else if (
    checkPrivileges("account") &&
    !checkPrivileges("device") &&
    !checkPrivileges("group")
  ) {
    controleSession();
    return null;
  } else {
    defaultPages.forEach((page) => {
      if (checkPrivileges(page))
        props.navigate(page === "device" ? "/units" : `/${page}s`);
    });
    return null;
  }
};

export default connect()(withRoutes(GarageInvoiceView));
